import { create } from 'zustand';
import { clearFinanceUnlockToken } from '../services/financeLockSession';

const storedToken = localStorage.getItem('token');
const storedUser = localStorage.getItem('user');

const useAuthStore = create((set) => ({
  user: storedUser ? JSON.parse(storedUser) : null,
  token: storedToken,
  login: (token, user) => {
    clearFinanceUnlockToken();
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token, user });
  },
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    clearFinanceUnlockToken();
    set({ token: null, user: null });
  },
  setUser: (user) => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
    set({ user });
  },
}));

export default useAuthStore;
